export const HOME_MENU_KEY = "home";
export const TRACK_APPLICATION_MENU_KEY = "trackApplication";
export const MY_COURSES_MENU_KEY = "myCourses";
export const MY_RESULTS_MENU_KEY = "myResults";
export const JOBS_MENU_KEY = "jobs";
export const SHORTLISTED_MENU_KEY = "shortlisted";
export const SELECTED_MENU_KEY = "selected";

export type SidebarMenuKey =
	| typeof HOME_MENU_KEY
	| typeof TRACK_APPLICATION_MENU_KEY
	| typeof MY_COURSES_MENU_KEY
	| typeof MY_RESULTS_MENU_KEY
	| typeof JOBS_MENU_KEY
	| typeof SHORTLISTED_MENU_KEY
	| typeof SELECTED_MENU_KEY;
